{
  "translate": "Translate",
  "done": "Done",
  "amount": "Amount",
  "timeline": "Timeline",
  "moneyAvailable": "Cash Available",
  "marketValue": "Total Assets",
  "availableFundsToWithdraw": "Available Funds to Withdraw",
  "netContributions": "Net Contributions",
  "simpleReturnPercent": "Simple RoR",
  "timeWeightedReturn": "Time Weighted RoR",
  "moneyWeightedReturn": "Money Weighted RoR",
  "newContribution": "New Contributions (Today)",
  "cashOnHoldToWithdraw": "Cash On Hold To Withdraw",
  "cashOnHoldToTrade": "Cash On Hold To Trade",
  "startDate": "Start Date",
  "subAccount": "Sub-account",
  "suspicious": "Suspicious",
  "notSuspicious": "Not Suspicious",
  "suspiciousActivity": "Suspicious activity",
  "suspiciousActivityDetected": "Suspicious activity detected",
  "noSuspiciousActivity": "No suspicious activity",
  "fraudRiskScore": "Fraud Risk Score",
  "lastUpdatedBy": "Updated By",
  "riskReasons": "Risk Reasons",
  "clientGroup": "Client Group",
  "corporation": "Corporation",
  "household": "Household",
  "edit": "Edit",
  "accountHighlights": "Account Highlights",
  "highlights": "Highlights",
  "groupEmployer": "Group Employer",
  "groupNumber": "Group Number",
  "displaySettledCash": "Settled Cash",
  "displayUnsettledCash": "Unsettled Cash",
  "displayAccountRepCode": "Rep code",
  "portfolioHighlights": "Portfolio Highlights",
  "accountNo": "Account No",
  "accountOwners": "Owners",
  "accountOwner": "Owner",
  "status": "Status",
  "YTDContributions": "{{label}} year to date",
  "first60DaysContributions": "{{label}} in first 60 days {{year}}",
  "last10MonthsContributions": "Remainder of {{year}}",
  "withdrawalsCurrentYear": "Withdrawals in current year",
  "minWithdrawalCurrentYear": "Minimum Withdrawal in current year",
  "maxWithdrawalCurrentYear": "Maximum Withdrawal in current year",
  "YTDDeposits": "Deposits year to date",
  "YTDWithdrawals": "Withdrawals year to date",
  "governContributions": "Government {{label}}",
  "currentYearContributions": "Current year {{label}}",
  "currentYearWithdrawals": "Current year withdrawals",
  "priorYearContributions": "Prior year {{label}}",
  "priorYearWithdrawals": "Prior year withdrawals",
  "portfolioFundFacts": "Portfolio fund facts",
  "languages": {
    "label": "Preferred language"
  },
  "languageSelection": {
    "language": "Language",
    "languageList": {
      "en": "English",
      "fr": "Français",
      "es": "Español"
    }
  },
  "notificationSettings": {
    "title": "Desktop notification settings",
    "options": {
      "inApp": "In-app",
      "push": "Push",
      "email": "Email"
    }
  },
  "updateAvatar": {
    "title": "Update Avatar"
  },
  "gender": "Gender",
  "preferredMethodOfCommunication": {
    "label": "Preferred method of communication"
  },
  "bankAccountSelect": {
    "addBank": "Add bank account",
    "information": {
      "header": "Add a bank account",
      "title": "Securely link your bank and investment accounts to streamline your investing journey.",
      "body": "Bank-level data encryption ensures your information is protected. No credentials are stored.",
      "addAccountBtn": "Add account",
      "addManuallyBtn": "I want to add my account manually"
    },
    "flinks": {
      "addManually": "I want to add my account manually",
      "linkingTimeInfo": "Linking may take up to 5 minutes...",
      "linkingRedirectionInfo": "After your bank account is successfully linked, you will automatically be redirected back to the previous screen."
    },
    "addBankModal": {
      "title": "Add Bank Account",
      "bankAccountName": "Bank account name",
      "institutionNumber": "Institution number",
      "transitNumber": "Transit number",
      "bankAccount": "Bank account",
      "inputErrors": {
        "bankAccountNameCannotBeEmpty": "Bank account name cannot be empty",
        "institutionNumberCannotBeEmpty": "Institution number cannot be empty",
        "routingNumberCannotBeEmpty": "Routing number cannot be empty",
        "institutionNumberLength": "Institution number must be 3 digits long",
        "routingNumberLength": "Routing number must be 9 digits long",
        "transitNumberCannotBeEmpty": "Transit number cannot be empty",
        "transitNumberLength": "Transit number must be 5 digits long",
        "bankAccountNumberCannotBeEmpty": "Bank account number cannot be empty",
        "bankAccountNumberRange": "Bank account needs to be between 5 and 17 digits long",
        "usBankAccountNumberRange": "Bank account must to be between 8 and 12 digits long"
      }
    },
    "addBankManuallyModal": {
      "title": "Add Bank Account",
      "subTitle": "Please input the account holder information and upload a void cheque for the account you would like to add",
      "bankAccountName": "Bank Account Name",
      "transitNumber": "Transit #",
      "institutionNumber": "Institution #",
      "accountNumber": "Account #",
      "bankAccount": "Bank account",
      "addBankAccount": "Add account",
      "linkFlinksButton": "I want to add my account automatically",
      "inputErrors": {
        "transitNumber": "Please enter a valid transit number",
        "accountNumber": "Please enter a valid Bank account number"
      },
      "bankAccountHolderName": "Bank Account Holder Name (optional)",
      "bankTransitAddress": "Bank Transit Address (optional)",
      "bankCountry": "Bank Jurisdiction",
      "routingNumber": "Routing #"
    },
    "deleteBankAccountModal": {
      "title": "Are you sure?",
      "body": "You will not be able to recover this bank account and will need to add another one."
    },
    "confirmationDialogTitle": "Are you sure?",
    "bankAccountAddedIntegrationToastMessage": "The bank account was added successfully.",
    "bankAccountAddedToastMessage": "The bank account was added successfully with the uploaded void cheque.",
    "bankAccountAddedToastMessageError": "Unable to add bank account. Please try again or contact support."
  },
  "address": {
    "title": "Edit - Address",
    "unitNumber": "Unit number",
    "houseNumber": "Street number",
    "streetName": "Street name",
    "city": "City",
    "province": "Province",
    "state": "State",
    "postal": "Postal code",
    "postcode": "Postcode",
    "zip": "ZIP code",
    "jurisdiction": "Jurisdiction",
    "mailAddressCheck": "Do you have a different mailing address from your home/legal address?",
    "alternateAddressCheck": "Do you have an alternate address that is different from your mailing & home address?",
    "line1": "Line 1",
    "line2": "Line 2",
    "country": "Country",
    "enterYourAddressManually": "Enter your address manually",
    "here": "here.",
    "clearAddress": "Clear address",
    "error": {
      "unSupportedCountry": "The selected country isn't supported. Please contact your advisor for help",
      "unSupportedProvince": "The selected province isn't supported. Please contact your advisor for help"
    }
  },
  "citizenshipInput": {
    "label": "Citizenships",
    "searchLabel": "Country",
    "updateButton": "UPDATE"
  },
  "transferTransitions": {
    "initiate": "Initiate",
    "ready": "Ready",
    "request": "Request",
    "process": "Process",
    "reconcile": "Reconcile",
    "review": "Review",
    "fail": "Fail",
    "cancel": "Cancel Transfer",
    "cancelReconciled": "Cancel",
    "reason": "Reason",
    "cancelScheduled": "Cancel Scheduled Transfer",
    "failtitle": "Fail Transfer",
    "canceltitle": "Cancel Transfer",
    "abort": "Abort",
    "confirm": "Confirm",
    "flipCancelToReconcile": "Reconcile Transfer",
    "editScheduled": "Edit Scheduled Transfer"
  },
  "transferTable": {
    "state": "State",
    "type": "Type",
    "source": "Source"
  },
  "tradeTransitions": {
    "process": "Process",
    "reconcile": "Reconcile",
    "fail": "Fail",
    "cancel": "Cancel",
    "forceCancel": "Cancel",
    "cancelReconciled": "Cancel"
  },
  "reportTransitions": {
    "review": "Review",
    "approved": "Approved",
    "denied": "Denied"
  },
  "loginSettings": {
    "title": "Manage Login",
    "changePassword": "Change password",
    "resetPasswordSuccess": "We've sent you an email to reset your password."
  },
  "activityTable": {
    "client": "Client",
    "account": "Account",
    "accountType": "Account Type",
    "type": "Type",
    "source": "Source",
    "sourceId": "Source ID",
    "amount": "Amount",
    "state": "State",
    "autoTransfer": "Auto Transfer",
    "frequency": "Frequency",
    "nextScheduledDate": "Next Scheduled Date",
    "createdAt": "Created",
    "reconciledAt": "Reconciled",
    "actions": "Actions",
    "alertState": "Alert State",
    "alert": "Alert",
    "alertDescription": "Description",
    "fraudRisk": "FinCrime Score",
    "noTransfersExist": "No transfers available",
    "noTransfersExistWithFilter": "No transfers match the filter criteria",
    "noScheduledTransfersExist": "You don’t have any scheduled transfers",
    "noUpcomingTransfersExist": "You don’t have any upcoming transactions",
    "noScheduledIncomeFundTransfersExist": "No Scheduled Income Fund transfers available",
    "dob": "Date of birth",
    "depositTo": "Deposit to",
    "paymentType": "Payment type",
    "instantInvest": "Instant Invest",
    "initiatedByRepresentative": "Initiated By Representative",
    "organization": "Organization",
    "scheduledDate": "Scheduled date",
    "bankAccount": "Bank Account",
    "bankAccountId": "Bank Account ID",
    "subAccount": "Sub-Account",
    "failReason": "Fail Reason",
    "user": "User",
    "userFirstName": "User First Name",
    "userMiddleName": "User Middle Name",
    "userLastName": "User Last Name",
    "endDate": "End Date",
    "toSubAccount": "To Sub-Account",
    "transferAll": "Transfer All",
    "withdrawalReason": "Withdrawal Reason",
    "withdrawalReasonDescription": "Withdrawal Reason Description",
    "subAccountGoalName": "Sub-Account Goal Name",
    "subAccountAccountType": "Sub-Account Account Type",
    "unrealizedGainsAndLossCents": "Unrealized Gains and Losses (Cents)",
    "unrealizedGainsAndLossCentsPercentage": "Unrealized Gains and Losses (Percentage)",
    "accountFileName": "Accounts"
  },
  "custodianActivities": {
    "exportProgressTitle": "Exporting external activities",
    "title": "Custodian Activities",
    "accountId": "Account ID",
    "accountType": "Account Type",
    "accountNumber": "Account Number",
    "transactionType": "Transaction Type",
    "transactionDesc": "Description",
    "currency": "Currency",
    "security": "Security",
    "quantity": "Quantity",
    "price": "Price",
    "amount": "Amount",
    "state": "State",
    "effectiveDate": "Effective Date",
    "processDate": "Process Date",
    "settleDate": "Settle Date",
    "modal": {
      "activityDetails": "Activity Details",
      "reconcileButton": "Reconcile",
      "forceReconcileButton": "Force Reconcile"
    }
  },
  "transfers": {
    "title": "Transfers",
    "exportProgressTitle": "Exporting transfers",
    "exportProgressTitleOneOff": "Exporting transfers",
    "exportProgressTitleScheduled": "Exporting scheduled transfers",
    "transferDetails": "Transfer Details",
    "transferProgress": "Transfer Progress",
    "source": "Source",
    "date": "Scheduled Date",
    "frequency": "Frequency",
    "setState": "Set State",
    "confirmationDialog": {
      "cancelScheduled": "This will cancel all future transfers scheduled for this series. Do you want to continue?",
      "cancel": "This will cancel the transfer. Do you want to continue?"
    },
    "cancel": "No, keep transfer",
    "confirm": "Yes, cancel transfer",
    "transitionSuccess": "Transfer state successfully changed",
    "cancelTransferSuccess": "Transfer canceled successfully",
    "cancelScheduledTransferSuccess": "Scheduled transfer canceled successfully",
    "createAdjustmentTransfer": "Add",
    "createAdjustmentTransferTitle": "Create Adjustment Transfer"
  },
  "transferUpdate": {
    "sourceIdRequired": "Source ID is required",
    "bankAccountIdRequired": "Bank Account ID is required"
  },
  "transfersTable": {
    "tableHeader": "Transfers",
    "scheduleTableHeader": "Scheduled Transfers",
    "paymentInstructions": "Payment Instructions",
    "yes": "Yes",
    "no": "No",
    "frequencyOption": {
      "ONE_TIME": "One-Time",
      "DAILY": "Daily",
      "WEEKLY": "Weekly",
      "SEMI_MONTHLY": "Semi-Monthly",
      "MONTHLY": "Monthly",
      "BI_WEEKLY": "Bi-Weekly",
      "QUARTERLY": "Quarterly"
    },
    "addTransfer": "Add Transfer",
    "userFirstName": "User First Name",
    "userLastName": "User Last Name",
    "account": "Account ID",
    "subAccount": "Sub-Account ID",
    "bankAccount": "Bank Account ID",
    "custodianAccountNumber": "Custodian Account Number",
    "dividendFor": "Dividend for",
    "source": "Source",
    "sourceId": "Source ID",
    "value:": "Value",
    "createdAt": "Created",
    "reconciledAt": "Reconciled"
  },
  "trades": {
    "title": "Trades",
    "tradeDetails": "Trade Details",
    "exportProgressTitle": "Exporting trades",
    "tradeProgress": "Trade Progress",
    "quantity": "Quantity",
    "estimatedQuantity": "Estimated Quantity",
    "security": "Security",
    "symbol": "Symbol",
    "price": "Price",
    "estimatedPrice": "Estimated Price"
  },
  "tradeTable": {
    "noTradesExist": "You don’t have any trade orders",
    "client": "Client",
    "account": "Account",
    "custodianAccountNumber": "Custodian Account Number",
    "type": "Type",
    "security": "Security",
    "quantity": "Quantity",
    "price": "Price",
    "actualQuantity": "Actual Quantity",
    "actualPrice": "Actual Price",
    "expectedQuantity": "Expected Quantity",
    "expectedPrice": "Expected Price",
    "expectedTotalValue": "Trade Value",
    "totalValue": "Value",
    "state": "State",
    "tradeDate": "Trade Date",
    "settlementDate": "Settlement Date",
    "createdAt": "Created",
    "reconciledAt": "Reconciled",
    "actions": "Actions",
    "cancel": "Cancel",
    "remove": "Remove From Bulk Trade Run",
    "currency": "Currency",
    "rebalance": "Rebalance",
    "user": "User",
    "userFirstName": "User First Name",
    "userLastName": "User Last Name",
    "organization": "Organization"
  },
  "bulkTradeRunAllocationsTable": {
    "externalId": "External ID",
    "account": "Account",
    "settlementCurrency": "Settlement Currency",
    "tradeCurrency": "Trade Currency",
    "side": "Side",
    "symbol": "Symbol",
    "market": "Market",
    "fillPrice": "Fill Price",
    "shareQuantity": "Share Quantity",
    "tradeDate": "Trade Date",
    "settlementDate": "Settlement Date",
    "tradeValue": "Trade Value",
    "corporateOffsetAccount": "Corporate Offset Account",
    "fXRate": "FX Rate"
  },
  "any": "Any",
  "close": "Close",
  "type": "Type",
  "filter": "Filter",
  "fromDate": "From",
  "toDate": "To",
  "security": "Security",
  "upcomingTransaction": {
    "fileName": "Upcoming Transactions",
    "progressTitle": "Packaging upcoming transactions",
    "errorStateTitleUpcomingTransactions": "Unable to load transactions"
  },
  "transaction": {
    "title": "Past Transactions",
    "noTransactions": "You don’t have any past transactions",
    "errorStateTitleLedgerTransactions": "Unable to load transactions",
    "noTransactionsExistWithFilter": "No transactions match the filter criteria",
    "fileName": "transactions",
    "progressTitle": "Packaging transactions",
    "exportProgressTitle": "Exporting transactions",
    "requested": "Requested",
    "reconciled": "Reconciled",
    "pendingConfirmation": "Pending Confirmation",
    "expectedSettlementDate": "Expected settlement on: {{settlementDate}}",
    "estimateFinalValue": "Estimate may not be final value",
    "table": {
      "client": "Client",
      "account": "Account",
      "accountType": "Account Type",
      "type": "Type",
      "switchType": "Switch Type",
      "quantity": "Quantity",
      "valueCents": "Value",
      "date": "Date",
      "initiatedDate": "Initiated Date",
      "processedDate": "Processed Date",
      "description": "Details",
      "actions": "Actions",
      "state": "State",
      "source": "Source",
      "goal": "Goal",
      "frequency": "Frequency",
      "priceCents": "Cost Price",
      "bookCost": "Book Cost (ACB/unit)",
      "bookValue": "Book Value",
      "currency": "Currency",
      "settleDate": "Settle Date",
      "settleDateToWithdraw": "Settle Date To Withdraw",
      "subAccount": "Sub-Account",
      "user": "User",
      "userFirstName": "User First Name",
      "userLastName": "User Last Name",
      "organization": "Organization",
      "objectType": "Object Type",
      "objectId": "Object Id",
      "householdClientGroup": "Household Client Group"
    },
    "actions": {
      "update": "Update",
      "delete": "Delete"
    },
    "types": {
      "EFT": "EFT",
      "CANCEL_EFT": "Canceled EFT",
      "BUY": "Buy trade",
      "CANCEL_BUY": "Canceled Buy trade",
      "DSC_FEE": "DSC Fee",
      "SELL": "Sell trade",
      "CANCEL_SELL": "Canceled Sell trade",
      "DIVIDEND": "Dividend",
      "EXTERNAL_TRANSFER_IN": "External Transfer In",
      "EXTERNAL_TRANSFER_OUT": "External Transfer Out",
      "TRANSFER_IN": "From Other Portfolio",
      "TRANSFER_OUT": "To Other Portfolio",
      "CANCEL_TRANSFER": "Canceled Transfer",
      "CORPORATE_ACTION": "Corporate Action",
      "CANCEL_CORPORATE_ACTION": "Canceled Corporate Action",
      "MANAGEMENT_FEE": "Management Fee",
      "CANCEL_MANAGEMENT_FEE": "Canceled Management Fee",
      "BORROW_FEE": "Borrow Fee",
      "MISC_FEE": "Miscellaneous Fee",
      "INTEREST": "Interest",
      "RISK_EXPOSURE_FEE": "Risk Exposure Fee",
      "WITHHOLDING_TAX": "Withholding Tax",
      "DEREGISTRATION_FEE": "Deregistration Fee",
      "DEREGISTRATION_TAX": "Deregistration Tax",
      "GST": "GST",
      "HST": "HST",
      "ADJUSTMENT": "Adjustment",
      "GOV_CONTRIBUTIONS": "Government Contributions",
      "SWITCH_IN": "Switch In",
      "CANCEL_SWITCH_IN": "Cancel Switch In",
      "CANCEL_SWITCH_OUT": "Cancel Switch Out",
      "DISTRIBUTION": "Distribution",
      "CHEQUE": "Cheque",
      "DEPOSIT_BUY": "Deposit Buy",
      "DISTRIBUTION_REINVESTMENT": "Distribution Reinvestment",
      "EXTERNAL_TRANSFER_IN_SECURITY": "External Transfer In Security",
      "EXPENSE": "Expense",
      "OTHER": "Other",
      "TRANSFER_IN_SECURITY": "Transfer In Security",
      "TRANSFER_OUT_SECURITY": "Transfer Out Security",
      "SWITCH_OUT": "Switch Out",
      "SWI_MARKET": "SWI Market",
      "SWI_COST": "SWI Cost",
      "SWO_MARKET": "SWO Market",
      "SWO_COST": "SWO Cost",
      "MARKET_DRIP": "Market Drip",
      "CUSTODY_FEE": "Custody Fee",
      "INCOME_FUND_TRANSFER": "Income Fund Transfer",
      "ACCRUED_INTEREST": "Accrued Interest",
      "CANADA_LEARNING_BOND": "Canada Learning Bond",
      "COMMISSION": "Commission",
      "DISABILITY_ASSISTANCE_PAYMENT": "Disability Assistance Payment",
      "ADD_CAD_EDU_SAVING_GRANT": "Additional Canada Education Saving Grant",
      "HOME_BUYER_PLAN": "Home Buyer Plan",
      "LIFE_LEARNING_PLAN": "Life Learning Plan",
      "MANAGEMENT_FEE_REDEMPTION": "Management Fee Redemption",
      "REBATE": "Rebate",
      "REDEMPTION": "Redemption",
      "RETURN_OF_CAPITAL": "Return Of Capital",
      "WIRE_TRANSFER": "Wire Transfer",
      "WRITE_OFF": "Write Off",
      "STOCK_DRIP": "Stock Drip",
      "CANCEL_BORROW_FEE": "Cancel Borrow Fee",
      "CANCEL_CHEQUE": "Cancel Cheque",
      "CANCEL_DEPOSIT": "Cancel Deposit",
      "CANCEL_FEE": "Cancel Fee",
      "CANCEL_HST": "Cancel HST",
      "CANCEL_INTEREST": "Cancel Interest",
      "CANCEL_REBATE": "Cancel Rebate",
      "CANCEL_TRANSFER_IN": "Cancel Transfer In Security",
      "CANCEL_TRANSFER_OUT": "Cancel Transfer Out Security",
      "FEDERAL_TAX": "Federal Tax",
      "SHORT_TERM_GAIN_LOSS": "Short Term Gain Loss",
      "LONG_TERM_GAIN_LOSS": "Long Term Gain Loss",
      "NON_EDU_CAPITAL_WITHDRAWAL": "Non-educational Capital Withdrawal",
      "CANCEL_ADJUSTMENT": "Cancel Adjustment",
      "CONTRIBUTION": "Contribution",
      "BOOK_VALUE_ADJUSTMENT": "Book Value Adjustment",
      "JOURNAL": "Journal",
      "CANCEL_JOURNAL": "Cancel Journal",
      "FOREIGN_TAX": "Foreign Tax",
      "TRANSFERS_EXCHANGES": "Transfers / Exchanges"
    },
    "currencies": {
      "CAD": "CAD",
      "USD": "USD"
    },
    "switchMenuItem": {
      "SWITCH": "Switch"
    },
    "switchTypes": {
      "AT_COST": "At Cost",
      "AT_MARKET": "At Market"
    },
    "journalTypes": {
      "CASH": "Cash Only",
      "SECURITY": "Security Only",
      "BOTH": "Security + Cash"
    },
    "newTransaction": {
      "createdToastMessage": "Adjustment transaction has been created.",
      "journalCreatedToastMessage": "Journal transactions have been created.",
      "errorToastMessage": "Failed to create transaction. Please try again.",
      "title": "New Transaction",
      "portfolio": "Portfolio",
      "date": "Date",
      "amount": "Amount",
      "details": "Details",
      "financialProduct": "Product",
      "quantity": "Quantity",
      "price": "Price",
      "pricePerUnit": "Price Per Unit",
      "adjustmentType": "Adjustment Type",
      "interestType": "Interest Type",
      "adjustedCostBase": "Adjusted Cost Base",
      "journalType": "Journal Type",
      "toSubAccount": "To Sub-Account",
      "additionalCash": "Additional Cash",
      "noValidTargetSubAccounts": "No valid sub-accounts available for transfer. Please select a different portfolio that has other sub-accounts in the same account with matching currency.",
      "noSecurityHoldings": "This portfolio has no security holdings available for transfer. Only portfolios with securities can be used for SECURITY or BOTH journal transactions.",
      "priceExceedsHoldingValue": "Price × Quantity exceeds available holding value",
      "currentMarketPrice": "Current market price: {{price}}",
      "interestTypes": {
        "DEPOSIT": "Interest Income",
        "WITHDRAW": "Interest Charged"
      },
      "security": "Security",
      "bookValue": "Book Value",
      "executionOrder": "Execution Order",
      "executionOrderHelp": "Transaction processing order for same-date transactions (0=first, 1=second)",
      "invalidDescription": "Details contains invalid characters"
    },
    "switchTransaction": {
      "outSecurity": "Switch Out Security",
      "inSecurity": "Switch In Security",
      "switchInPrice": "Switch In ACB",
      "valueCents": "Total Market Value",
      "quantity": "Quantity",
      "priceCents": "Switch Out ACB",
      "switchedToastMessage": "Switch transactions have been created.",
      "isExistingHolding": "The Switch Out Security is currently held in this portfolio.",
      "atCostInfo": "The price per unit of the Switch In Security is the total cost of the security switched out / quantity switched in.",
      "atMarketInfo": "The price per unit of the Switch In Security is its current market price."
    },
    "updateTransaction": {
      "title": "Update Transaction",
      "updatedToastMessage": "Transaction has been updated.",
      "errorToastMessage": "Failed to update transaction. Please try again.",
      "pendingWarning": "This transaction is currently pending and cannot be modified."
    },
    "deleteTransaction": {
      "deletedToastMessage": "Transaction has been deleted.",
      "journalDeletedToastMessage": "Journal transactions have been deleted.",
      "errorToastMessage": "Failed to delete transaction. Please try again.",
      "title": "Delete Transaction",
      "body": "Are you sure you want to delete this transaction?"
    }
  },
  "transferSources": {
    "USER": "Client Initiated",
    "REPRESENTATIVE": "Representative Initiated",
    "FEE": "Management Fee",
    "DEREGISTRATION": "Deregistration Fee",
    "DEREGISTRATION_TAX": "Deregistration Tax",
    "WITHHOLDING_TAX": "Withholding Tax",
    "DIVIDEND": "Dividend",
    "TO_SUB_ACCOUNT": "To Other Portfolio",
    "FROM_SUB_ACCOUNT": "From Other Portfolio",
    "TO_ACCOUNT": "To Other Account",
    "FROM_ACCOUNT": "From Other Account",
    "EXTERNAL_TRANSFER_IN": "External Transfer In",
    "EXTERNAL_TRANSFER_OUT": "External Transfer Out",
    "ADJUSTMENT": "Adjustment",
    "CUSTODIAN_ACTIVITY": "Custodian Activity",
    "GOV_CONTRIBUTIONS": "Government Contributions",
    "INCOME_FUND_TRANSFER": "Income Fund Transfer",
    "CHEQUE": "Cheque",
    "DISTRIBUTION": "Distribution",
    "DSC_FEE": "DSC Fee"
  },
  "transferTo": "To {{subAccount}}",
  "transferFrom": "From {{subAccount}}",
  "ruleTypes": {
    "ABOVE_LIQUIDITY": "Above Liquidity",
    "ABOVE_NETWORTH": "Above NetWorth",
    "ADVERSE_NEWS": "Adverse News",
    "DEPOSIT_IN_SAME_TIMEFRAME": "Deposit in the same timeframe",
    "DORMANT_ACCOUNT": "Dormant Account",
    "FOR_ACCOUNT_PURPOSE": "For Account Purpose",
    "HIGH_RISK_USER": "High Risk User",
    "LARGE_DEPOSIT": "Large Deposit",
    "LARGE_EXTERNAL_TRANSFER": "Large External Transfer",
    "LARGE_WITHDRAW_IN_SHORT_TIME": "Large Withdrawal in Short Time",
    "MULTIPLE_DEPOSIT_IN_SHORT_TIME": "Multiple Deposits in Short Time",
    "HAS_MULTIPLE_LARGE_DEPOSITS": "Multiple large Deposits",
    "HAS_MULTIPLE_LARGE_WITHDRAWALS": "Multiple large Withdrawals",
    "LARGE_WITHDRAWAL": "Large Withdrawal",
    "WITHDRAWAL_TO_NEW_BANK_ACCOUNT": "Withdrawal to new bank account"
  },
  "alertReportStates": {
    "INITIATED": "Initiated",
    "REVIEW": "Review",
    "APPROVED": "Approved",
    "DENIED": "Denied"
  },
  "subAccountTable": {
    "account": "Account",
    "goal": "Goal",
    "theme": "Theme",
    "suggestedPortfolio": "Suggested Portfolio",
    "portfolio": "Portfolio",
    "requireIPS": "Require IPS",
    "allowClientDeposits": "Client Deposits Allowed",
    "allowFractionalShares": "Allow Fractional Shares",
    "nextDeposit": "Next Deposit",
    "assets": "Total Assets",
    "state": "State",
    "actions": "Actions",
    "Yes": "Yes",
    "No": "No",
    "True": "True",
    "False": "False"
  },
  "subAccountState": {
    "AWAITING_APPROVAL": "Awaiting Approval",
    "ACTIVE": "Active",
    "INACTIVE": "Closed",
    "WITHDRAW_ALL": "Withdraw All"
  },
  "subAccountTransitions": {
    "activate": "Activate",
    "review": "Review",
    "deactivate": "Deactivate"
  },
  "scheduledFundTransferModal": {
    "warningToastMessage": "You already have a scheduled transfer in {{content}}, please cancel the transfer in this account before creating another one.",
    "editTitle": "Edit Payment Instructions",
    "title": "New Payment Instructions",
    "edit": "Edit",
    "archive": "Archive",
    "years": "years",
    "dateOfBirth": "Age to calculate the minimum payment",
    "typeOfAnnualPaymentAmount": "Type of annual payment amount",
    "amountPayableType": "Type of amount",
    "schedule": "Payment schedule",
    "scheduledDate": "Scheduled date",
    "scheduleOptions": {
      "SEMI_ANNUALLY": "Semi Annually",
      "QUARTERLY": "Quarterly",
      "ANNUALLY": "Annually",
      "MONTHLY": "Monthly"
    },
    "annualAmountCents": "Annual amount cents",
    "amount": "Amount",
    "typeOfAnnualPaymentAmountSources": {
      "custom": "Custom",
      "minimumAnnualPayment": "Minimum annual payment"
    },
    "amountPayableTypeSources": {
      "gross": "GROSS",
      "net": "NET"
    },
    "starting": "Starting",
    "taxOptionType": "Tax option type",
    "taxOptions": {
      "NO_TAX_ON_MINIMUM": "No tax on minimum",
      "SPECIAL_TAX_RATE": "Special tax rate",
      "TAX_ON_FULL": "Tax on full"
    },
    "subAccount": "Sub-account",
    "bankAccount": "Deposit payment to",
    "specialTaxRate": "Special Tax Rate"
  },
  "transferModal": {
    "title": "New Transfer",
    "updateTitle": "Update Transfer",
    "updateBtnTitle": "Update",
    "schedule": "Schedule",
    "starting": "Starting",
    "scheduleOptions": {
      "ONE_TIME": "Just this once",
      "WEEKLY": "Weekly",
      "BI_WEEKLY": "Bi-weekly",
      "MONTHLY": "Monthly",
      "QUARTERLY": "Quarterly",
      "SEMI_MONTHLY": "Semi-Monthly"
    },
    "startingOptions": {
      "now": "Now",
      "futureDate": "Future Date"
    },
    "sources": {
      "adjustment": "Adjustment",
      "eft": "EFT",
      "ALL_IN_CASH": "Full",
      "PARTIAL_CASH": "Partial",
      "ALL_IN_KIND": "Full in kind",
      "externalTransferIn": "External Transfer In",
      "transferToSubAccount": "Transfer to other portfolio",
      "cheque": "Cheque"
    },
    "externalTransfer": {
      "method": "Transfer method",
      "allInCash": "All in cash",
      "partialCash": "Partial cash",
      "allInKind": "All in kind",
      "institution": "Institution",
      "transferAccountNumber": "Transfer account number",
      "relinquishingInstitution": "Relinquishing Institution",
      "accountTypeAndNumber": "Account (Type, Number)",
      "account": "Account",
      "signedTransferForm": "signed transfer form",
      "downloadSignedTransferForm": "Download signed transfer form",
      "signedTransferFormBtnText": "Signed Transfer Form"
    },
    "type": "Type",
    "source": "Source",
    "deposit": "Deposit",
    "withdraw": "Withdraw",
    "portfolio": "Portfolio",
    "choosePortfolio": "Choose portfolio",
    "fromPortfolio": "From Portfolio",
    "toPortfolio": "To Portfolio",
    "bankAccount": "Bank Account",
    "amount": "Amount",
    "totalTransferAmount": "Total Transfer Amount",
    "clbTransferAmount": "CLB Transfer Amount",
    "bcGrantTransferAmount": "BC Grant Transfer Amount",
    "transferAll": "Transfer all funds",
    "withdrawAll": "Withdraw All",
    "exceedWithdrawAllWarning": "This will be a full withdrawal where all securities will be sold and the funds will be sent to your chosen bank account. Please tag this as a withdraw all or lower the amount.",
    "exceedTransferAllWarning": "This will be a full transfer where all securities will be sold and the funds will be sent to your chosen portfolio. Please tag this as a transfer all funds or lower the amount.",
    "adjustmentReason": "Adjustment Reason",
    "createdToastMessage": "Transfer has been created.",
    "fetchingFees": "Feething fees ...",
    "eftOut": "EFT Out",
    "withdrawalMode": "Withdrawal Mode",
    "gross": "Gross",
    "net": "Net",
    "netAmount": "Net Amount",
    "minRecurringDepositAmount": "This is your minimum scheduled deposit amount:",
    "minAmountDeposit": "This is your minimum deposit amount:",
    "minInitialDeposit": "This is your minimum initial deposit amount:",
    "depositGreaterThanZero": "Deposit amount must be greater than 0",
    "selectScheduleFirst": "Please select a schedule to continue",
    "insufficientCurrencyBalance": "Insufficient {{currency}} balance. Available: {{available}}",
    "availableCash": "Available: {{amount}}",
    "availableQuantity": "Available: {{quantity}} shares",
    "availableValue": "Available: {{amount}}",
    "stateTaxTitle": "State tax withholding rate",
    "federalTaxTitle": "Federal tax withholding rate"
  },
  "tradeModal": {
    "title": "New Trade",
    "types": {
      "buy": "Buy",
      "sell": "Sell"
    },
    "type": "Type",
    "portfolio": "Portfolio",
    "financialProduct": "Product",
    "price": "Price / Adjusted Cost Base",
    "quantity": "Quantity",
    "effectiveDate": "Effective Date",
    "description": "Description",
    "createdToastMessage": "Trade has been created.",
    "fractionalToastMessage": "This product does not allow fractional trades.",
    "isReconciled": "Reconciled Trade",
    "createExternalTransfer": "Create matching external transfer for transfer in kind"
  },
  "goalType": {
    "CAR": "Car",
    "BUILD_WEALTH": "Build Wealth",
    "RETIREMENT": "Retirement",
    "MAJOR_PURCHASE": "Major Purchase",
    "HOUSE": "House",
    "EDUCATION": "Education",
    "VACATION": "Vacation",
    "START_A_BUSINESS": "Start a Business",
    "WEDDING": "Wedding",
    "PARENTAL_LEAVE": "Parental Leave",
    "SAFETY_NET": "Safety Net",
    "OTHER": "Other"
  },
  "taxInformationField": {
    "label": "Pays Foreign Taxes",
    "country": "Country",
    "tin": "Tax Identification Number"
  },
  "externalInstitutionSelect": {
    "confirmButton": "Confirm",
    "selectInstitutionDialog": {
      "title": "Select financial Institution",
      "addManually": "+ Add institution Manually",
      "addInstitution": "+ Add new institution"
    },
    "addInstitutionDialog": {
      "title": "Add Institution Manually",
      "institutionNameLabel": "Institution Name",
      "addManually": "+ Add institution Manually"
    }
  },
  "scheduleDateSelect": {
    "title": "On the...",
    "label": "Scheduled date",
    "suffix": "day of the month"
  },
  "booleanOptions": {
    "yes": "Yes",
    "no": "No"
  },
  "simpleDateRangePicker": {
    "fromDate": "From",
    "toDate": "To"
  },
  "householdModelPortfolio": {
    "initialize": "Initialize",
    "edit": "Edit",
    "tabs": {
      "model": "Model",
      "ips": "IPS"
    },
    "noIpsFieldsConfigured": "No IPS fields configured",
    "ipsContentPending": "IPS content will appear here when configured fields are enabled.",
    "noAccess": "You do not have permission to view model portfolios.",
    "error": "Unable to load the household model portfolio.",
    "modelDetails": {
      "title": "Model Details",
      "noModelAttached": "No model portfolio is attached to this household yet.",
      "error": "Unable to load model details."
    },
    "allocation": {
      "error": "Unable to load asset allocation.",
      "noSecurities": "No securities are allocated to this model portfolio yet."
    },
    "ips": {
      "error": "Unable to load IPS content.",
      "noTargetAllocations": "No target allocations are configured for this model portfolio yet."
    }
  },
  "householdPortfolio": {
    "attachModel": "Attach model",
    "selectTheme": "Theme",
    "selectModel": "Model portfolio",
    "attachModelSuccess": "Model attached",
    "attachModelError": "Couldn't attach the model. Please try again.",
    "noModelAttached": "No model portfolio is attached to this household yet. Attach one to view the portfolio.",
    "modelAttachedNoMembers": "A model portfolio is attached. The household portfolio will appear once this household has at least one sub-account.",
    "inheritedFromHousehold": "This account inherits the household model portfolio.",
    "goalInheritedFromHousehold": "This goal inherits the household model portfolio.",
    "goalLoadFailedName": "Selected goal",
    "goalLoadFailed": "Couldn't load this goal's household portfolio details. Select a theme and model manually, or try again later.",
    "managePortfolio": "Manage household portfolio",
    "detachModel": "Detach model",
    "detachModelTitle": "Detach model from household?",
    "detachModelBody": "This removes the household model portfolio. The portfolio tab will be empty until a new model is attached. Custom allocation overrides will be cleared.",
    "detachModelSuccess": "Model detached",
    "detachModelError": "Couldn't detach the model. Please try again.",
    "tradingProcess": "Trading process",
    "updateSuccess": "Household portfolio updated",
    "updateError": "Couldn't update the household portfolio. Please try again.",
    "tradingProcessRequired": "Select a trading process",
    "portfolioStillBeingPrepared": "The household portfolio is still being prepared. Please try again in a moment.",
    "methodology": "Allocation Methodology",
    "unified": "Unified",
    "customized": "Customized",
    "unit": "Input unit",
    "unitDollar": "$",
    "unitPercent": "%",
    "customTarget": "Custom target",
    "customTargetInputLabel": "Custom target for {{security}} in {{member}}",
    "recalculate": "Recalculate",
    "save": "Save",
    "unsavedChangesTitle": "Discard changes?",
    "unsavedChangesBody": "You have unsaved allocation changes. Discard them?",
    "unsavedAllocationGateTitle": "Unsaved allocation changes",
    "unsavedAllocationGateBody": "You have unsaved custom allocation changes. You can proceed without saving, or go back and save first.",
    "proceedWithoutSaving": "Proceed without saving",
    "goBackAndSaveFirst": "Go back and save first",
    "inactiveMembersInTotalsNotice": "This household includes inactive members. Recalculate and Save use them in the portfolio totals — toggle \"View Inactive Sub-Accounts\" to see what Recalculate produced.",
    "resetCustomTargets": "Reset",
    "resetCustomTargetsTitle": "Reset custom targets?",
    "resetCustomTargetsBody": "This resets all member custom targets back to the household model. Unsaved edits will be lost.",
    "saveCustomAllocationsSuccess": "Custom targets saved",
    "resetCustomAllocationsSuccess": "Custom targets reset",
    "errors": {
      "generic": "Something went wrong. Please try again.",
      "NOT_ACCESSIBLE": "Customized allocations require more than one member account.",
      "NOT_CUSTOMIZED": "This report is not in Customized mode. Refreshing…",
      "WRONG_REPORT_MEMBER": "The member set changed. Refreshing the report…",
      "PRODUCT_NOT_HELD": "This security isn't held in this account.",
      "CAPACITY_BREACH": "Allocation must be between 0% and 100%.",
      "WEIGHT_SUM_OUT_OF_RANGE": "This account's allocations don't sum correctly.",
      "AMOUNT_SUM_OUT_OF_RANGE": "This account's dollar amounts don't sum correctly.",
      "AGGREGATE_CONSERVATION": "Household totals don't match the model target.",
      "BAD_USER_INPUT": "No changes to save.",
      "LOCKS_INFEASIBLE": "Those overrides cannot be satisfied — locked amounts exceed household or account limits.",
      "SOLVE_FAILED": "Could not rebalance unlocked targets. Try adjusting your overrides."
    },
    "advisoryViolations": {
      "WEIGHT_SUM": "Highlighted custom targets: one or more accounts' security allocations don't add up to the investable total (excluding cash). Adjust your overrides or lock fewer cells, then Recalculate.",
      "ROW_DRIFT": "Highlighted custom targets: a household fund total doesn't match the model target. Adjust locked values or change which cells you override.",
      "MULTIPLE": "Some recalculated custom targets are highlighted because they don't balance with your overrides. Review highlighted fields or adjust locked values, then Recalculate."
    }
  },
  "portfolio": "Portfolio",
  "viewPreTradePositions": "View Market Value Pre-trade Positions",
  "viewInactiveSubAccounts": "View Inactive Sub-Accounts",
  "viewPortfolioWideTargetPercentages": "Show portfolio-wide target %",
  "portfolioLastUpdated": "Last updated {{date}}",
  "portfolioFxRate": "FX Rate {{from}} to {{to}}: {{fxRate}}",
  "holdingsExchangeRate": "Exchange rate: 1 {{fromCurrency}} = {{rate}} {{toCurrency}}",
  "portfolioWarnings": {
    "accountIsBlocked": "Trades will not be executed because the account is not active and/or approved",
    "subAccountIsBlocked": "Trades will not be executed because the sub-account is not active and/or approved",
    "illiquidProducts": "Illiquid product trades will only be available to trade on the next scheduled date(s): {{datesAndTickers}}",
    "pendingTransactionUsdCurrency": "USD security trade orders {{tickers}} have been executed but are pending reconciliation and may differ than the amount displayed",
    "pendingTransactionMfSellAll": "Sell all mutual fund orders {{tickers}} have been executed but are pending reconciliation and may differ than the amount displayed",
    "pendingSplitsInCompletedTrades": "There are pending splits in the completed trades table."
  },
  "bulkTradeRequestIsNotFound": "Error: The bulk trade request associated with the current portfolio optimizer was not found!",
  "errorOccurredWhileLoadingPortfolio": "An error occurred while loading the portfolio!",
  "errorPortfolioViewUnderHousehold": "The model portfolio is assigned to the household. Please view it on the household page.",
  "errorPortfolioViewUnderGoal": "The model portfolio is assigned to the goal. Please view it on the goal page.",
  "errorPortfolioViewUnderSubAccount": "The model portfolio is assigned to a sub-account. Please view it on the sub-account page.",
  "errorPortfolioViewUnderSubAccounts": "Model portfolios are assigned at the sub-account level. Please view them on the relevant sub-account pages.",
  "errorPortfolioStillBeingPrepared": "The portfolio is still being prepared. Please try again in a moment.",
  "errorPortfolioNoModelAssigned": "No model portfolio is assigned at this level.",
  "revert": "Revert",
  "autoFillToTarget": "AutoFill to Target",
  "autoRebalance": "Auto-rebalance",
  "optimizer": "Optimizer",
  "optimizerDisabledReason": "Optimizer is unavailable due to active pending transactions",
  "optimizerEmptyRun": {
    "internalDriftAdvisory": "This portfolio has internal drift within an asset class. Internal drift is advisory only and does not trigger automated drift rebalancing. Use Auto Fill to Target or enter trades manually.",
    "notDriftEligible": "This portfolio is not drift-eligible — it is within the drift tolerance band at the screening level, so the optimizer did not propose trades.",
    "notProcessed": "The optimizer did not process this portfolio for this run.",
    "pendingTrades": "Trades are still pending on this portfolio."
  },
  "showPairs": "Show Pairs",
  "canadianCash": "Canadian Dollars",
  "pendingReconciliationAlerts": {
    "usdSecurityMessage": "USD security trade orders {{tickers}} have been executed but are pending reconciliation and may differ than the amount displayed",
    "mfSellAllMessage": "Sell all mutual fund orders {{tickers}} have been executed but are pending reconciliation and may differ than the amount displayed"
  },
  "portfolioTable": {
    "assetGroup": "Asset Group",
    "collapseRow": "Collapse row",
    "expandRow": "Expand row",
    "deleteAssetClass": "Delete asset class",
    "security": "Security",
    "current": "Current",
    "target": "Target",
    "original": "Original: {{amount}}",
    "pendingWithdraw": "Pending withdraw: {{amount}}",
    "deviation": "Deviation",
    "cash": "Cash",
    "total": "Total",
    "taxRank": "Tax Rank",
    "subAccountIsInactive": "This Sub-Account is inactive and cannot be traded",
    "settles": "Settles",
    "settling": "Settling",
    "initiatedBuy": "Buy",
    "initiatedSell": "Sell",
    "initiatedSellAll": "Sell All",
    "requestedBuy": "Buy",
    "requestedSell": "Sell",
    "requestedSellAll": "Sell All",
    "sellAll": "SELL ALL"
  },
  "noRecordsFound": "No records were found",
  "generateTrades": {
    "confirmTrades": "Confirm Trades",
    "completeTrades": "Complete Batch",
    "cancelTrades": "Cancel All Trades",
    "cancelSelectedTrades": "Cancel Selected Trades",
    "cancelSubTradeRequest": "Cancel Trade",
    "cancelSubTradeRequestSuccess": "Trade cancelled successfully",
    "cancelSubTradeRequestError": "Failed to cancel trade",
    "exportTrades": "Export Trades",
    "nothingToExport": "Nothing to export",
    "verifyTradesResult": "Trades were marked as verified",
    "unverifyTradesResult": "Trades were marked as unverified",
    "verifyUnverifyTradesResult": "Trades were marked as verified/unverified",
    "confirm": "Confirm",
    "tradesSent": "Trades Created",
    "activeTradeRequests": "Active Trade Requests",
    "completedTradeRequests": "Completed Trade Requests",
    "generatedByPortfolioOptimizer": "Generated by a Portfolio Optimizer on {{portfolioOptimizerCreatedAt}}",
    "noActiveTradeRequests": "No Active Trade Requests",
    "noCompletedTradeRequests": "No Completed Trade Requests",
    "tradesToBeCanceled": "Trades that will be canceled",
    "verifyUnverifyTrades": "Verify/Unverify Trades",
    "allSplitsAreVerified": "All of the splits are verified",
    "someSplitsAreNotVerified": "Some of the splits are not verified",
    "errorCreatingTrades": "Unable to create trades",
    "types": {
      "BUY": "Buy",
      "SELL": "Sell"
    },
    "table": {
      "account": "Account",
      "accountType": "Client Account Type",
      "custodianAccountNumber": "Client Account Number",
      "type": "Type",
      "amount": "Amount",
      "currency": "Currency",
      "security": "Security",
      "securityTicker": "Security Ticker",
      "securityName": "Security Name",
      "settlementDays": "Settlement Days",
      "exchange": "Exchange",
      "settlementDate": "Settlement Date",
      "state": "State",
      "pairedWith": "Paired With",
      "selectAll": "Select All Trades To Verify/Unverify",
      "selectAllTradesToCancel": "Select All Trades To Cancel",
      "selectAllTradesToVerifyOrCancel": "Select All Trades To Verify/Unverify Or Cancel",
      "verifiedAt": "Verified",
      "actions": "Actions"
    }
  },
  "tradePairsModal": {
    "modalTitle": "Pairs That Were Created",
    "buys": "Buys",
    "pairedWith": "Paired With",
    "sells": "Sells",
    "noPair": "No Pair",
    "totalBuys": "Total Dollar Amount of Buys",
    "totalSells": "Total Dollar Amount of Sells",
    "sellAll": "Sell All"
  },
  "inherited": " - (inherited)",
  "includePendingTrades": "Include Pending Trades",
  "pendingTransfers": {
    "title": "Pending Transactions",
    "details": "Transaction Details",
    "cancelTransaction": "Cancel Transaction",
    "cancelScheduledTransaction": "Cancel Schedule",
    "types": {
      "WITHDRAW": "Withdraw",
      "DEPOSIT": "Deposit"
    },
    "states": {
      "INITIATED": "Initiated",
      "READY": "Ready",
      "REQUESTED": "Requested",
      "PROCESSING": "Processing",
      "ACTIVE": "Active",
      "REVIEWING": "Reviewing",
      "RECONCILED": "Reconciled",
      "FAILED": "Failed",
      "CANCELED": "Canceled"
    }
  },
  "beneficiaryCrud": {
    "beneficiaryName": "Beneficiary Name",
    "relationshipToAccountHolder": "Relationship to account holder",
    "allocation": "Allocation",
    "addAffiliate": "Add Affiliate",
    "allocationError": "Total allocation must equal 100%"
  },
  "householdMembers": {
    "title": "Members"
  },
  "changeTheme": {
    "portfolioTheme": "Portfolio Theme",
    "modelPortfolio": "Model Portfolio",
    "suggested": "Suggested",
    "unset": "Unset",
    "save": "Save changes",
    "noOptionsAvailable": "No available model portfolios",
    "noSuitabilityScore": "You need to answer all of your suitability questions before you can choose a theme",
    "modelPortfolioRequired": "Model portfolio is required"
  },
  "recentTransactions": {
    "title": "Recent Investment Details"
  },
  "newsAndInsights": {
    "title": "News & Insights"
  },
  "contacts": {
    "title": "Contact Your Advisor"
  },
  "advisorContact": {
    "loading": "Loading advisor contact…",
    "loadFailed": "Unable to load advisor contact information."
  },
  "accessToEntity": {
    "title": "Access",
    "table": {
      "name": "Name",
      "email": "Email",
      "accessType": "Access Type",
      "relation": "Relation"
    },
    "accessTypes": {
      "fullAccess": "Full Access",
      "limitedAccess": "Limited Access"
    },
    "oraganizationAccessRow": "Users with access to the {{org}} entities.",
    "relations": {
      "ADVISOR": "Advisor",
      "OTHER": "Other",
      "OWNER": "Client (Owner)",
      "POWER_OF_ATTORNEY": "Power of Attorney"
    },
    "editButton": {
      "title": "Edit Access to {{entityName}}",
      "update": "Update"
    },
    "addButton": {
      "formTitle": "Grant access to {{entityName}}",
      "relationLabel": "Relation",
      "grantAccessButton": "Grant Access",
      "orgUserSearchText": "User",
      "entitySearchText": "Entities",
      "accounts": "Accounts",
      "allowAccessToSpecificAccounts": "Allow access only to specific accounts",
      "noAccountsSelectedError": "No specific accounts selected—this user will have no access under this entity",
      "toggle": {
        "create": "Create new user",
        "invite": "Invite an existing user"
      },
      "createTab": {
        "firstName": "First Name",
        "lastName": "Last Name",
        "relation": "Relation",
        "email": "Email",
        "organization": "Organization",
        "role": "Role",
        "roleToAccessEntity": "Role to access entity",
        "noRoleSelected": "If no role is selected, access will be granted based on the organization user's role.",
        "autoInviteUser": "Auto invite user",
        "emailError": "This user already exists. Invite the existing user."
      }
    },
    "confirmationModal": {
      "title": "Are you sure?",
      "bodyText": "Are you sure you want to remove the access of {{orgUserName}} to the {{entityName}} profile?"
    }
  },
  "additionalInfoModal": {
    "title": "What this means"
  },
  "viewAllProfilesDialog": {
    "switchProfile": "Switch Profile",
    "viewDetails": "View Details",
    "addNewEntity": "Add new profile"
  },
  "translatableString": {
    "errorText": "Missing field"
  },
  "subTradeRequestTableDialog": {
    "title": "Are you sure you want to cancel this Trade Request?"
  },
  "exportConfiguration": {
    "title": "Export configuration",
    "fileName": "File name",
    "useAdditionalFilter": "Apply filter to the export",
    "mainColumns": "Main columns",
    "additionalColumns": "Additional columns",
    "selectAllColumns": "Select all columns",
    "exportButton": "Export",
    "dateRange": "Date Range",
    "fromDate": "From Date",
    "toDate": "To Date",
    "specifyDateRange": "Specify date range",
    "dateRangeError": "Date range cannot exceed {{days}} days",
    "maxDateRange": "Max date range is {{days}} days",
    "futureDateError": "Date cannot be in the future",
    "startDateAfterEndError": "Start date cannot be after end date",
    "bothDatesRequiredError": "Enter both From and To dates, or clear both.",
    "invalidDateError": "Invalid date"
  },
  "dateRangeField": {
    "from": "From",
    "to": "To",
    "clear": "Clear",
    "apply": "Apply"
  },
  "downloadButton": {
    "failedDownloadMessage": "File not downloaded",
    "progressModalTitle": "Preparing export",
    "download": "Download",
    "noExportsFound": "No exports found",
    "recentExports": "Recent exports",
    "createExport": "Create export",
    "exportColumnsCount_one": "{{count}} column",
    "exportColumnsCount_other": "{{count}} columns",
    "exportProgressPercent": "{{percent}}%",
    "exportRefetchTimeout": "Export started but did not appear in the list. Refresh and try again."
  },
  "searchSecuritiesField": {
    "nothingFoundMessage": "No securities found with that ticker."
  },
  "marketValueChart": {
    "netContributions": "Net Contributions:"
  },
  "view": "View",
  "fundFacts": "Fund facts",
  "ruleBuilder": {
    "addRule": "Add Rule",
    "addGroup": "Add Group",
    "removeRuleGroup": "Remove Group",
    "noAvailableRules": "No fields are available for this object type. Add a custom field for it to build a condition.",
    "and": "AND",
    "or": "OR",
    "operators": {
      "equals": "Equals",
      "notEquals": "Not Equals",
      "contains": "Contains",
      "notContains": "Does Not Contain",
      "startsWith": "Starts With",
      "endsWith": "Ends With",
      "greaterThan": "Greater Than",
      "greaterThanOrEquals": "Greater Than or Equal To",
      "lessThan": "Less Than",
      "lessThanOrEquals": "Less Than or Equal To",
      "in": "In",
      "notIn": "Not In",
      "exists": "Exists",
      "notExist": "Does Not Exist",
      "isEmpty": "Is Empty",
      "isNotEmpty": "Is Not Empty",
      "isTrue": "Is True",
      "isFalse": "Is False",
      "isBefore": "Is Before",
      "isAfter": "Is After",
      "includes": "Includes",
      "notIncludes": "Does Not Include"
    }
  },
  "rules": {
    "state": "State",
    "marketValue": "Market Value",
    "age": "Age",
    "dateOfBirth": "Date of Birth",
    "accountType": "Account Type",
    "createdAt": "Created At"
  },
  "datePicker": {
    "cancelButtonLabel": "Cancel",
    "okButtonLabel": "OK",
    "datePickerDefaultToolbarTitle": "Select date",
    "dateTimePickerDefaultToolbarTitle": "Select date and time"
  },
  "fieldValidation": {
    "required": "Please fill out this field.",
    "enterNumber": "Please enter a number."
  },
  "autocomplete": {
    "noOptions": "No results",
    "loading": "Searching…",
    "loadingMore": "Loading more…",
    "typeToSearch": "Type to search",
    "minChars": "Type at least {{count}} characters"
  },
  "fieldErrors": {
    "default": "{{fieldName}} required",
    "phone": "Please enter a valid phone number",
    "email": "Please enter a valid email address",
    "address": "Please enter a complete address",
    "selectionTile": "Please select an option"
  },
  "productShelf": {
    "exportHeaders": {
      "ticker": "Ticker",
      "name": "Name",
      "exchange": "Exchange",
      "primaryAssetClass": "Primary Asset Class",
      "secondaryAssetClass": "Secondary Asset Class",
      "substitute": "Substitute Product",
      "taxRank": "Tax Rank",
      "tradeSchedule": "Trade Schedule",
      "currency": "Currency",
      "currentPrice": "Current Price",
      "originalCurrency": "Original Currency",
      "originalPrice": "Original Price",
      "autoUpdatePrice": "Auto Update Price",
      "historyDate": "History Date",
      "priceHistory": "Price History",
      "holdingsQuantityHistory": "Holdings Quantity History",
      "holdingsValueHistory": "Holdings Value History",
      "cusip": "CUSIP",
      "fundSeries": "Fund Series",
      "volatile": "Volatile",
      "isPartial": "Fractional",
      "tertiaryAssetClass": "Tertiary Asset Class",
      "waivedFeePercentage": "Waived Fee Percentage",
      "settlementDays": "Settlement Days",
      "url": "URL",
      "isin": "ISIN",
      "ric": "RIC",
      "type": "Type",
      "multiplier": "Multiplier"
    },
    "exportConfig": {
      "includeHistory": "Include Price History",
      "historyFrom": "History From",
      "historyTo": "History To",
      "progressTitle": "Exporting Product Shelf Data"
    }
  },
  "featureFlags": {
    "inheritedSetTo": "Inherited set to",
    "true": "Yes",
    "false": "No"
  },
  "updateTransferModal": {
    "title": "Update Transfer",
    "source": "Source",
    "amount": "Amount",
    "type": "Type",
    "updatedToastMessage": "Transfer has been updated."
  },
  "modelPortfolioHolding": {
    "noPortfolioHolding": "No holdings breakdown available",
    "errorStateTitlePortfolioHolding": "Unable to load holdings breakdown"
  },
  "holdings": {
    "noHoldings": "You don't have any holdings",
    "errorStateTitleHoldings": "Unable to load holdings"
  },
  "customFieldsDisplay": {
    "noCustomFields": "You don't have any custom fields"
  },
  "affiliateConversion": {
    "inviteUser": "Invite User",
    "edit": "Edit",
    "delete": "Delete",
    "confirmation": {
      "title": "Are you sure?",
      "subTitle": "Please confirm that you are assigning the correct entity user ({{entityUserEmail}})"
    }
  },
  "usaContributionTypes": {
    "REGULAR": "Regular",
    "EMPLOYEE": "Employee",
    "EMPLOYER": "Employer",
    "RECHARACTERIZATION": "Recharacterization",
    "ROLLOVER_60_DAY": "60 Day Rollover",
    "ROLLOVER_DIRECT": "Direct Rollover",
    "TRANSFER": "Transfer",
    "TRUSTEE_FEE": "Trustee Fee",
    "CONVERSION": "Conversion",
    "REPAYMENT": "Repayment"
  },
  "usaContributionTypeTitle": "Contribution Type",
  "fiscalYearTitle": "Fiscal Year",
  "clientSelect": {
    "affiliate": "Affiliate",
    "selectUser": "Select User"
  },
  "usaWithdrawalReasons": {
    "IRA_DISTRIBUTION_TYPE_UNKNOWN": "IRA Distribution Type Unknown",
    "NORMAL": "Normal",
    "DISABILITY": "Disability",
    "SOSEPP": "Sosepp",
    "PREMATURE": "Premature",
    "DEATH": "Death",
    "EXCESS_CONTRIBUTION_REMOVAL_BEFORE_TAX_DEADLINE": "Excess Contribution Removal Before Tax Deadline",
    "EXCESS_CONTRIBUTION_REMOVAL_AFTER_TAX_DEADLINE": "Excess Contribution Removal After Tax Deadline",
    "ROLLOVER_TO_QUALIFIED_PLAN": "Rollover to Qualified Plan",
    "ROLLOVER_TO_IRA": "Rollover to IRA",
    "DISTRIBUTION_TRANSFER": "Distribution Transfer",
    "RECHARACTERIZATION_PRIOR_YEAR": "Recharacterization Prior Year",
    "RECHARACTERIZATION_CURRENT_YEAR": "Recharacterization Current Year",
    "DISTRIBUTION_CONVERSION": "Distribution Conversion",
    "MANAGEMENT_FEE": "Management Fee",
    "PLAN_LOAN_401_K": "401K Plan Loan",
    "PREMATURE_SIMPLE_IRA_LESS_THAN_2_YEARS": "Premature Simple IRA Less than 2 Years",
    "NORMAL_ROTH_IRA_GREATER_THAN_5_YEARS": "Normal Roth IRA Greater than 5 Years"
  },
  "usaWithdrawalReasonTitle": "Withdrawal Reason",
  "stateTaxMessages": {
    "info": {
      "mandatory": "{{state}} requires state tax withholding (min. {{minTaxWithholding}}%) when federal tax is withheld. If you are exempt from federal withholding, you can opt out. If you choose to withhold, the minimum still applies.",
      "mandatoryOptOut": "{{state}} requires state tax withholding (min. {{minTaxWithholding}}%) when federal tax is withheld. A state-specific form is needed to opt out, but this is not currently supported. If you are exempt from federal withholding, you can opt out. If you choose to withhold, the minimum still applies.",
      "noElection": "{{state}} does not allow state income tax withholding for IRA distributions.",
      "voluntaryWithMinimum": "For {{state}}, you are not required to withhold any funds for state tax withholding. However if you choose to withhold, the minimum is {{minTaxWithholding}}%.",
      "voluntary": "For {{state}}, you do not need to withhold any funds for State Tax Withholding.",
      "stateSpecific": {
        "DC": "For {{state}}, you are not required to withhold any funds for state tax withholding if you are not fully closing your IRA account. However, if you are fully closing your IRA account, a minimum of {{minTaxWithholding}}% is required.",
        "CA": "For {{state}}, you are not required to withhold any funds for state tax withholding. However if you choose to withhold, the minimum is {{minTaxWithholding}}% of your federal tax withholding.",
        "VT": "{{state}} requires state tax withholding when federal tax is withheld. The minimum is {{minTaxWithholding}}% of your federal tax withholding.",
        "MS": "{{state}} law requires state tax withholding only on Roth IRA distributions that are considered premature or excess withdrawals. Voluntary withholding is not allowed. We are unable to determine if your specific distribution meets these criteria. To understand if state tax withholding is required for your withdrawal, please contact your advisor."
      }
    },
    "validation": {
      "minTaxWithholding": "You must withhold at least {{minTaxWithholding}}% for State Tax Withholding.",
      "optOutOrMinTaxWithholding": "State Tax withholding rate should be {{optOutTaxWithholding}}% or greater than {{minTaxWithholding}}%"
    }
  },
  "tableColumns": {
    "account": "Account",
    "type": "Type",
    "source": "Source",
    "state": "State",
    "createdAt": "Created At",
    "value": "Value",
    "scheduledAt": "Date",
    "securityName": "Security Name",
    "frequency": "Frequency",
    "bankAccountInstitution": "Bank Account Institution Number",
    "bankAccountTransitNumber": "Bank Account Transit Number",
    "bankAccountNumber": "Bank Account Number",
    "accountId": "Account ID",
    "firstName": "User First Name",
    "lastName": "User Last Name",
    "currency": "Currency",
    "subAccount": "Sub-Account",
    "goal": "Goal",
    "user": "User",
    "organization": "Organization",
    "householdClientGroup": "Household Client Group",
    "symbol": "Symbol",
    "quantity": "Quantity",
    "bookCost": "Book Cost",
    "currentPrice": "Current Price",
    "unrealizedGainLoss": "G/L Unrealized",
    "oneDayChange": "1-Day Change",
    "percentOfTotal": "% of Total",
    "marketValueNative": "Market Value (Native)",
    "marketValue": "Market Value",
    "name": "Name",
    "holder": "Holder",
    "nickname": "Nickname",
    "repCode": "Rep Code",
    "accountNumber": "Account #",
    "program": "Program",
    "currentValue": "Current Value",
    "amount": "Amount",
    "nextScheduledDate": "Next Scheduled Date",
    "costPrice": "Cost Price",
    "date": "Date",
    "accountGroupName": "Account Group Name",
    "numberOfAccounts": "Number of Accounts",
    "security": "Security",
    "assetClass": "Asset Class",
    "taxRank": "Tax Rank",
    "targetPercentage": "Target %",
    "actualPrice": "Actual Price",
    "actualQuantity": "Actual Quantity",
    "expectedPrice": "Expected Price",
    "expectedQuantity": "Expected Quantity",
    "reconciledAt": "Reconciled"
  },
  "accountGroups": {
    "noAccountGroupsExist": "No account groups exist",
    "errorFetchingAccountGroups": "Unable to load account groups"
  },
  "tableColumnDescriptions": {
    "localCost": "The cost of the security on a per share basis in the currency in which it was executed in",
    "localBookValue": "The total cost of the security in the currency in which it was executed in",
    "nativeCost": "The Native cost of the security on a per share basis exchanged to the accounts Native currency",
    "nativeBookValue": "The total cost of the security converted to the Native currency of the account",
    "custodianBookValue": "The Book value for the holdings as reported by the custodian",
    "fxRate": "Historical FX rate that was utilized during the exchange to purchase the security"
  },
  "driftSettings": {
    "label": "Effective drift policy: {{method}} ±{{tolerance}}%",
    "inheritedFromModelPortfolio": " (inherited from model portfolio)"
  }
}
